import ThankYouPage from "@/components/ThankYouPage";

const MerciAppelPlanDeMatch = () => (
  <ThankYouPage
    eventName="Lead"

    contentName="Appel 15 min · Plan de match"
    title="C'est confirmé."
    body={`Vous allez recevoir une invitation par courriel avec le lien de la rencontre.

Ajoutez-la à votre calendrier tout de suite, ça évite les oublis.

On se parle bientôt.`}
    backTo="/plan-de-match"
    backLabel="Retour au plan de match"
    canonical="/merci/appel-plan-de-match"
  />
);

export default MerciAppelPlanDeMatch;
